export const GOOGLE_MAPS_API_KEY = 'AIzaSyCcGA2XPS9EOOPTZ1Pj-uBJK2PRt65JR5E';
export const AMPLITUDE_API_KEY = 'eade10d6f4746cbe34333e42ff653fbc';
